export class WrongPasswordError extends Error {
  // This gives the error type safety
  private readonly typeName = 'WrongPasswordError'
  public readonly name = this.typeName

  constructor(message?: string, options?: ErrorOptions) {
    super(message || 'Wrong password', options)
  }
}
